module.exports = __webpack_public_path__ + "media/images/teams/INTERNAZIONALE-564af737ae77b882f5765de153502ed6.png";